import { render } from "./loader_component.vue?vue&type=template&id=3e504c0e"
import script from "./loader_component.vue?vue&type=script&lang=js"
export * from "./loader_component.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__